import axios from "axios";
import { ENDPOINTS, getBaseURL } from "data/endpoints";
import { getHeaders } from "data/headers";

export const getCartCountApi = () => {
  return axios.get(getBaseURL() + ENDPOINTS.CART_COUNT, {
    headers: getHeaders(),
  });
};
